import { useEffect } from 'react';
import { ServicesBanner } from '../../assets/images';
import ImageBanner from '../../components/imageBanner';
import ServicesContent from '../../components/services';
import { Helmet } from 'react-helmet';

const Services = () => {

    useEffect(() => {
        document.title = 'Services - Prime Direct Distribution';
    }, [])

    return (
        <div className="services">
            <Helmet>
                <title>{'Services'}</title>
                <meta name="description" content={'Learn more about Prime Direct and the services we offer or get a quote.'} />
                <meta property="og:title" content={'Services'} />
                <meta property="og:description" content={'Learn more about Prime Direct and the services we offer or get a quote.'} />
            </Helmet>
            <ImageBanner image={ServicesBanner} />
            <ServicesContent />
        </div>
    )
}

export default Services;